import {Swiper} from "../../../common/ui/Swiper";
import {Spinner} from "react-bootstrap";
import React from "react";

/**
 * @param title
 * @param products
 * @param loading
 * @returns {JSX.Element}
 */
export const ProductSwiperBis = ({title = "", products = [], loading = false, children}) => {

    const itemChild = React.Children.toArray(children)
        .find(child => React.isValidElement(child) && child.type === ProductSwiperBis.Item)

    const loadSwiper = () =>
        products.length === 0 ? (
            <div className="alert alert-light">
                No hay productos
            </div>
        ) : (
            <Swiper>
                {
                    products.map((product, index) => (
                        <Swiper.Item key={index}>
                            {itemChild.props.children(product)}
                        </Swiper.Item>
                    ))
                }
            </Swiper>
        )

    return (
        <div className="row">
            <div className="col-12 align-self-start">
                <p className="bold text-primary fs-5">{title}</p>
            </div>
            <div className="col-12 p-3 rounded-2">
                {loading ? (
                    <Spinner animation="border" size="sm"/>
                ) : (
                    loadSwiper()
                )}
            </div>
        </div>
    );
};

ProductSwiperBis.Item = ({product, children}) => {
    if (typeof children !== "function") {
        throw new Error("ProductSwiperBis.Item requiere una función hija: {product => (...) }");
    }
    return product !== undefined ? children(product) : null;
};
